module.exports = __webpack_public_path__ + "static/media/like_outline.ec0668f7.svg";